import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RepositoryService } from 'src/app/service/repository.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'angular-toastify';
import { MatTabGroup } from '@angular/material/tabs';
import { JIRA_BOARD_PROJECT_Name } from 'src/app/constant/constant';

@Component({
  selector: 'app-createiamuseraccess',
  templateUrl: './createiamuseraccess.component.html',
  styleUrls: ['./createiamuseraccess.component.css']
})
export class CreateiamuseraccessComponent implements OnInit {


  cloudForm: FormGroup;
  compartmentNames: any = [];
  filteredComponentName: any[] = [];
  removable: boolean = true;
  addOnBlur: boolean = true;
  visible: boolean = true;
  selectable: boolean = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  appRepoApps: any = [];
  filteredappRepoApps: any = [];
  projectName: string = JIRA_BOARD_PROJECT_Name.OCI;
  summary: string;
  @Input() tabGroup!: MatTabGroup;
  constructor(private fb: FormBuilder, private rs: RepositoryService, private _toastService: ToastService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.cloudForm = this.fb.group({
      compartmentName: ['', [Validators.required]],
      appid: ['', [Validators.required]],
      nonWWID: this.fb.array([], [Validators.required]),
      policyAndPermission: this.fb.array([], [Validators.required])

    })
    this.loadOCICompartmentNames();
    this.getAppsFromAppRepo();

  }

  /**Loads OCI Compartments */
  private loadOCICompartmentNames(): void {
    this.spinner.show()
    this.rs.getOCIAccounts("All", "List").subscribe({
      next: (res) => {
        this.compartmentNames = res['Items'];
        this.filteredComponentName = [...this.compartmentNames];
        this.spinner.hide();
      },
      error: (error) => {
        this._toastService.error(error['message'])
        this.spinner.hide();
      }
    })


  }


  getAppsFromAppRepo() {
    this.spinner.show()
    this.rs.getAppsFromAppRepo("All").subscribe({
      next: (res) => {
        //console.log(JSON.stringify(res))
        this.appRepoApps = res["Items"].map(res => ({
          ...res,
          result: `${res.appname} ${res.appid}`
        }));
        this.filteredappRepoApps = [...this.appRepoApps];
        this.spinner.hide();
      },
      error: (error) => {
        this._toastService.error(error['message']);
        this.spinner.hide();
      }
    })


  }

  handleFilteredReturn(filteredData: any[]): void {
    this.filteredappRepoApps = filteredData
  }
  handleFilteredcomponentReturn(filteredData: any[]): void {
    this.filteredComponentName = filteredData
  }
  addChip(event: MatChipInputEvent, arrayName: string): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const policyAndPermissionArray = this.cloudForm?.get(arrayName) as FormArray;
      policyAndPermissionArray.push(this.fb.control({ name: value.trim() }));

    }
    if (input) {
      input.value = '';
    }
  }

  /**Handles removing chips */
  removeChip(value: { name: string }, arrayName: string): void {
    let index: number;

    const policyAndPermissionArray = this.cloudForm?.get(arrayName) as FormArray;

    // Find the index of the chip to be removed
    index = policyAndPermissionArray.value.findIndex((item: any) => item.name === value.name);
    if (index >= 0) {
      policyAndPermissionArray.removeAt(index); // Use the Angular FormArray method
    }

  }


  resetform(): void {
    this.cloudForm?.reset();
    this.cloudForm.setControl('nonWWID', this.fb.array([]));
    this.cloudForm.setControl('policyAndPermission', this.fb.array([]));
  }



  onSubmit(): void {
    this.spinner.show();
    this.summary = `Create IAM User on ${this.cloudForm.get('appid').value} for this ${this.cloudForm.get('compartmentName').value} `
    this.rs.createCloudServiceRequest(this.projectName, this.summary, this.cloudForm.value, sessionStorage.getItem("wwid")
    ).subscribe({
      next: (res) => {
        this._toastService.success(res['message']);
        this.resetform();
        if (this.tabGroup) { this.tabGroup.selectedIndex = 1 };
        this.spinner.hide();

      },
      error: (error) => {
        this._toastService.error(error?.message || "An unexpected error occurred.");
        this.spinner.hide();

      }
    });
  }

}
